import React from "react";

import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { useNavigate } from "react-router-dom";
import { REPORTS_IDS, REPORTS_NAMES } from "consts/reports";
import { routes } from "consts";
import { PaziaHeader } from "components/atoms/PaziaHeader/PaziaHeader";

export const ReportsPage = (): JSX.Element | null => {
  const navigate = useNavigate();

  return (
    <PageMain>
      <PaziaHeader>Raporty</PaziaHeader>

      <div>
        <div className="col-span-full xl:col-span-6 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700">
          <div className="p-3">
            {/* Card content */}
            {/* "Today" group */}
            {groups.map((group) => (
              <div key={group.name}>
                <header className="text-xs uppercase text-slate-400 dark:text-slate-500 bg-slate-50 dark:bg-slate-700 dark:bg-opacity-50 rounded-sm font-semibold p-2">
                  {group.name}
                </header>
                <ul className="my-1">
                  {/* Item */}
                  {group.reports.map((rep) => (
                    <li
                      className="flex px-2 cursor-pointer hover:bg-slate-200"
                      key={rep.name}
                      onClick={() => navigate(routes.REPORT(rep.id.toString()))}
                    >
                      <div className="w-9 h-9 rounded-full shrink-0 bg-primary-500 my-2 mr-3">
                        <svg className="w-9 h-9 fill-current text-primary-50" viewBox="0 0 36 36">
                          <path d="M18 10c-4.4 0-8 3.1-8 7s3.6 7 8 7h.6l5.4 2v-4.4c1.2-1.2 2-2.8 2-4.6 0-3.9-3.6-7-8-7zm4 10.8v2.3L18.9 22H18c-3.3 0-6-2.2-6-5s2.7-5 6-5 6 2.2 6 5c0 2.2-2 3.8-2 3.8z" />
                        </svg>
                      </div>
                      <div className="grow flex items-center border-b border-slate-100 dark:border-slate-700 text-sm py-2">
                        <div className="grow flex justify-between">
                          <div className="self-center">{rep.name}</div>
                          <div className="shrink-0 self-end ml-2">
                            <span className="font-medium text-primary-500 hover:text-primary-600 dark:hover:text-primary-400">
                              Zobacz<span className="hidden sm:inline"> -&gt;</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PageMain>
  );
};
type Group = {
  name: string;
  reports: {
    name: string;
    id: number;
  }[];
};
const groups: Group[] = [
  {
    name: "Finanse",
    reports: [
      { name: REPORTS_NAMES[REPORTS_IDS.COURSES_FINANCIAL_REPORT], id: REPORTS_IDS.COURSES_FINANCIAL_REPORT },
      {
        name: REPORTS_NAMES[REPORTS_IDS.COURSES_GROUP_FINANCIAL_REPORT],
        id: REPORTS_IDS.COURSES_GROUP_FINANCIAL_REPORT,
      },
    ],
  },
  {
    name: "Ankiety",
    reports: [
      { name: REPORTS_NAMES[REPORTS_IDS.SURVEYS_COURSES], id: REPORTS_IDS.SURVEYS_COURSES },
      { name: REPORTS_NAMES[REPORTS_IDS.SURVEYS_COURSE], id: REPORTS_IDS.SURVEYS_COURSE },
    ],
  },
  {
    name: "Użytkownicy",
    reports: [{ name: REPORTS_NAMES[REPORTS_IDS.USER_REGISTRATIONS], id: REPORTS_IDS.USER_REGISTRATIONS }],
  },
  {
    name: "Zapisy na kurs",
    reports: [
      {
        name: REPORTS_NAMES[REPORTS_IDS.COURSE_REGISTRATIONS_BY_COURSE],
        id: REPORTS_IDS.COURSE_REGISTRATIONS_BY_COURSE,
      },
    ],
  },
  {
    name: "Miejsca",
    reports: [{ name: REPORTS_NAMES[REPORTS_IDS.PLACE_COURSES], id: REPORTS_IDS.PLACE_COURSES }],
  },
];
